<div class="alert-item" [style.--alert-accent]="color()">
  <app-svg-icons [icons]="icon()" width="14" height="14" [color]="color()" stroke="transparent" />
  <span class="item-title">
    @for (link of alert().object_links; track link.object + ':' + link.object_id) {
      @if (resolveTarget(link); as target) {
        <b class="seg-link" clickableText [clickableTabIndex]="decorative() ? -1 : 0" (textClicked)="openEntity.emit(target)">{{ link.label }}</b>
      } @else {
        <b>{{ link.label }}</b>
      }
    }
    {{ alert().title }}
  </span>
</div>
